import { useState } from 'react';
import toast from 'react-hot-toast';
import Api from '../../../utils/Api';

const AddExternalList = ({ value: list, message, onNext }) => {
  const [url, setUrl] = useState('');

  const onSave = async () => {
    if (!url) return onNext(list);
    const [error, updatedList] = await Api.addSourceToList(list._id, url);
    if (error) {
      toast.error(Api.error(error));
      console.error(error);
    } else {
      onNext(updatedList, 'Your amazon list is being imported!');
    }
  }

  return (
    <div className='step'>
      <div>{message}</div>
      <div>Add an Amazon gift list URL to import (optional) </div>
      <input placeholder='Amazon list URL' value={url} onChange={e => setUrl(e.target.value)} />
      <div className='buttons'>
        <button className='primary' onClick={onSave}>Next</button>
      </div>
    </div>
  )
}

export default AddExternalList;